import { render, staticRenderFns } from "./CategoryDashboard.vue?vue&type=template&id=51acc460&"
import script from "./CategoryDashboard.vue?vue&type=script&lang=js&"
export * from "./CategoryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDashboard.vue?vue&type=style&index=0&id=51acc460&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports